export const text = {
  title: 'Forgot Password',
  subtitle: 'Enter your email and we will send you a reset code',
  sendCode: 'Send Code',
  verifyTitle: 'Reset Password',
  verifySubtitle: 'Enter the code from your email and choose a new password',
  reset: 'Reset Password',
  code: 'Reset Code',
  newPassword: 'New Password',
  backToLogin: 'Back to sign in',
  startOver: 'Start over',
  codePlaceholder: 'Enter the code from your email',
  newPasswordPlaceholder: 'Enter your new password',
  requestSuccess: 'Reset code sent. Check your email.',
  requestError: 'Could not send reset code. Please try again.',
  verifySuccess: 'Password reset successfully!',
  verifyInvalidPassword: 'Password must be at least 8 characters.',
  verifyError: 'Invalid or expired code. Please try again.',
};
